import React from 'react';
import CategoryManager, { CategoryFormData } from '../../components/base/CategoryManager';
import {
  useCategories,
  useCreateCategory,
  useUpdateCategory,
  useDeleteCategory,
} from '../../hooks/queries/useCategories';

const CategoriesContainer: React.FC = () => {
  // useCategories() returns tree structure by default
  const { data: categories = [], isLoading, error } = useCategories();
  const createMutation = useCreateCategory();
  const updateMutation = useUpdateCategory();
  const deleteMutation = useDeleteCategory();

  const handleAddSubmit = async (data: CategoryFormData) => {
    await createMutation.mutateAsync(data);
  };

  const handleEditSubmit = async (id: string, data: CategoryFormData) => {
    await updateMutation.mutateAsync({ id, data });
  };

  const handleDelete = async (id: string) => {
    await deleteMutation.mutateAsync(id);
  };

  if (error) {
    return (
      <div className="text-center py-8">
        <p className="text-red-500">Error loading categories. Please try again.</p>
      </div>
    );
  }

  return (
    <CategoryManager
      categories={categories}
      isLoading={isLoading}
      isSubmitting={createMutation.isPending || updateMutation.isPending || deleteMutation.isPending}
      onAddSubmit={handleAddSubmit}
      onEditSubmit={handleEditSubmit}
      onDelete={handleDelete}
    />
  );
};

export default CategoriesContainer;
